export default __webpack_public_path__ + "static/media/deleteTeamPopup.6c8607dc.svg";